export function getName(user) {
  try {
    return user && user.firstName && user.lastName
      ? `${user.firstName} ${user.lastName}`
      : user && user.firstName && !user.lastName
      ? `${user.firstName}`
      : user && user.lastName && !user.firstName
      ? `${user.lastName}`
      : null
  } catch (error) {
    console.log('error parsing name')
    return null
  }
}
